






















































import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// @ts-ignore
import vClickOutside from 'v-click-outside';
import { Debounce } from '@/functions/debounce';

@Component({
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    FormInput: () => import('@/components/forms/Input.vue'),
  },
})
export default class PartHeader extends Vue {
  @Getter('workspace/all') workspaces!: Workspace[];

  @Getter('workspace/selected') workspace!: Workspace;

  @Action('search/index') search!: (payload: { query?: string; type?: string; ids?: string }) => Promise<any>;

  @Action('workspace/index') indexWorkspaces!: () => Promise<Workspace[]>;

  @Getter('search/all') searchResults!: Search;

  @Prop({ default: 100 }) height!: number;

  searchString: string = '';

  focused: boolean = false;

  private handleSearch() {
    if (!this.searchString) {
      return;
    }

    this.search({ query: this.searchString });
  }

  @Watch('searchString')
  @Debounce(500)
  private onSearchStringChanged() {
    this.handleSearch();
  }
}
